import { MutationTree } from 'vuex'
import { IOrderState } from '@/store/order'
import { Types, Store, Current, Year, Method } from '@/store/order/types'

const mutations: MutationTree<IOrderState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.year]: (state, action: Year) => {
    state.year = action.payload
  },
  [Types.method]: (state, action: Method) => {
    state.method = action.payload
  }
}

export default mutations
